import { useEffect } from "react";

// Api

// Components
import Sidebar from "components/organisms/Sidebar";

// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";
import { useLoaderStore } from "stores/loader";
import { useSettingsStore } from "stores/settings";
import { useSplitServiceData } from "../../queries/useSplitServiceData";

const SidebarContainer = () => {
  const isSidebarOpen = useSettingsStore((state) => state.isSidebarOpen);
  const { loyaltyAccess } = useSplitServiceData();

  const { overlayLoading } = useLoaderStore();

  const { isCustomBreakpointSmaller } = useBreakpoint(1370);

  const { closeSidebar, openSidebar } = useSettingsStore((state) => ({
    closeSidebar: state.closeSidebar,
    openSidebar: state.openSidebar,
  }));

  useEffect(() => {
    if (isCustomBreakpointSmaller) {
      closeSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCustomBreakpointSmaller]);

  const handleToggle = (value: boolean) => {
    if (value) {
      openSidebar();
    } else {
      closeSidebar();
    }
  };

  return (
    <Sidebar
      isLoading={overlayLoading}
      isSidebarOpen={isSidebarOpen}
      onToggle={handleToggle}
      hasLoyalty={loyaltyAccess}
    />
  );
};

export default SidebarContainer;
